import {CheckoutLegacyMutationsCreateCartArgs, VolatileCartResponse} from '@wix/wixstores-graphql-schema-node';
import {GRAPHQL_SOURCE, graphqlOperation} from '../constants';
import {SPECS} from '../specs';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {query as createCartQuery} from '../../graphql/mutations/createCart.graphql';
import {GRAPHQL_NODE_ENDPOINT} from '@wix/wixstores-client-core/dist/es/src/dashboard/topology';
import {STORES_APP_DEF_ID} from '@wix/wixstores-client-core/dist/src/constants';
import {ICustomTextFields} from '@wix/wixstores-client-core/dist/src/types/product';

export function gqlNodeQuery(siteStore: SiteStore, query: string, variables: {}, operationName: string) {
  return siteStore.httpClient.post(siteStore.resolveAbsoluteUrl(`${GRAPHQL_NODE_ENDPOINT}`), {
    query,
    variables,
    source: GRAPHQL_SOURCE,
    operationName,
  });
}

export class CheckoutApiService {
  constructor(private readonly siteStore: SiteStore, private readonly wixCodeApi?: any) {}

  public async createCart(createCartParams: CheckoutLegacyMutationsCreateCartArgs): Promise<VolatileCartResponse> {
    if (this.siteStore.experiments.enabled(SPECS.BuyNowFromEcomSdk)) {
      return this.createCheckout(createCartParams);
    }

    const creatCartResponse: any = await gqlNodeQuery(
      this.siteStore,
      createCartQuery,
      createCartParams,
      graphqlOperation.CreateCart
    );

    /* istanbul ignore next: todo: test */
    if (creatCartResponse.errors) {
      throw new Error("Couldn't go to checkout due to volatileCartService error");
    }
    return creatCartResponse.data.checkout.createCart;
  }

  private async createCheckout(createCartParams: CheckoutLegacyMutationsCreateCartArgs): Promise<VolatileCartResponse> {
    const publicApi: any = await this.wixCodeApi.site.getPublicAPI(STORES_APP_DEF_ID);
    const isReturnCartIdNullInsteadOfDeprecatedForExpressService = this.siteStore.experiments.enabled(
      SPECS.ReturnCartIdNullInsteadOfDeprecatedForExpressService
    );

    const checkout = await publicApi.checkout.createCheckout(
      createCartParams.productId,
      createCartParams.quantity,
      {
        customTextFields: createCartParams.customTextFieldSelection as ICustomTextFields[],
        choices: createCartParams.options,
        optionsSelectionsIds: createCartParams.optionSelectionId,
        subscriptionOptionId: createCartParams.subscriptionOptionId,
        variantId: createCartParams.variantId,
      },
      createCartParams.preOrderRequested
    );

    return {
      id: isReturnCartIdNullInsteadOfDeprecatedForExpressService ? undefined : 'deprecated', // Cart ID is no longer needed
      checkoutId: checkout._id,
    } as VolatileCartResponse;
  }
}
